export default {
  'menu.providerManagement': '服務商管理',
  'menu.providerManagement.admission': '入駐管理',
  'menu.providerManagement.admissionApply': '申請入駐',
  'menu.providerManagement.providerCompanies': '主體管理',
  'menu.providerManagement.providerCompanyDetail': '主體資質詳情',
  'menu.admission': '入駐管理',
  'menu.admissionApply': '申請入駐',
  'menu.providerCompanies': '主體管理',
  'menu.providerCompanyDetail': '主體資質詳情',
  'menu.customerManagement': '客戶經營',
  'menu.customerManagement.leads': '線索',
  'menu.customerManagement.leadDetail': '線索詳情',
  'menu.customerManagement.customers': '企業客戶',
  'menu.customerManagement.customerDetail': '客戶詳情',
  'menu.customerManagement.opportunities': '服務機會',
  'menu.customerManagement.opportunityDetail': '機會詳情',
  'menu.customers': '企業客戶',
  'menu.customerDetail': '客戶詳情',
  'menu.opportunities': '服務機會',
  'menu.opportunityDetail': '機會詳情',
  'menu.businessManagement': '業務管理',
  'menu.businessManagement.products': '服務商品',
  'menu.businessManagement.products.productCreate': '新建商品',
  'menu.businessManagement.products.productEdit': '編輯商品',
  'menu.businessManagement.products.productDetail': '商品詳情',
  'menu.businessManagement.orders': '服務訂單',
  'menu.businessManagement.orders.orderDetail': '訂單詳情',
  'menu.products': '服務商品',
  'menu.productCreate': '新建商品',
  'menu.productEdit': '編輯商品',
  'menu.productDetail': '商品詳情',
  'menu.orders': '服務訂單',
  'menu.orderDetail': '訂單詳情',
  'menu.projects': '服務項目',
  'menu.projectDetail': '項目詳情',
  'menu.serviceQuality': '服務質量',
  'menu.serviceQuality.reviews': '服務評價',
  'menu.serviceQuality.qualityImprovements': '質量改進',
  'menu.reviews': '服務評價',
  'menu.qualityImprovements': '質量改進',
  'menu.analytics': '經營分析',
  'menu.settings.capabilities': '服務能力',
  'menu.settings.reviewTags': '評價標籤',
  'menu.capabilities': '服務能力',
  'menu.reviewTags': '評價標籤',
  'menu.workbench': '工作臺',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '系統設置',
  'menu.settings.permissions': '權限管理',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
